import { useQuery } from '@apollo/client/react';
import { VENDOR_ORDERS } from 'api/graphql/orders';
import { useVendor } from 'features/vendor';

// The screen filters orders into tabs client-side, so we fetch a generous first
// page. (Pagination/infinite-scroll can be layered on later if needed.)
const ORDERS_LIMIT = 50;

/** Orders for the active shop (most recent first page). */
export function useVendorOrders() {
  const { vendorId, loading: vendorLoading } = useVendor();

  const { data, loading, error, refetch } = useQuery(VENDOR_ORDERS, {
    variables: { vendorId, page: 1, limit: ORDERS_LIMIT },
    skip: !vendorId,
    notifyOnNetworkStatusChange: true,
  });

  const orders = data?.vendorOrders ?? [];

  return {
    orders,
    loading: vendorLoading || loading,
    error,
    refetch,
    // True when the first page is full — there may be older orders not shown.
    truncated: orders.length >= ORDERS_LIMIT,
  };
}
